import { WireframeCube } from "./cube";

// Smooth scrolling for navigation links
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener(
    "click",
    function (this: HTMLAnchorElement, e: Event) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href")!);
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  );
});

// Form submission handling
document
  .querySelector(".waitlist-form")
  ?.addEventListener("submit", function (this: HTMLFormElement, e: Event) {
    // Get form data for validation
    const formData = new FormData(this);
    const data = Object.fromEntries(formData);

    // Simple validation
    if (!data.email) {
      e.preventDefault();
      alert("Please enter your email address.");
      return;
    }

    // Show loading state
    const submitButton = this.querySelector(
      'button[type="submit"]'
    ) as HTMLButtonElement;
    submitButton.textContent = "Submitting...";
    submitButton.disabled = true;

    // Prevent default form submission and handle it manually
    e.preventDefault();

    // Create a hidden iframe to submit the form
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.name = "form-submit-iframe";
    document.body.appendChild(iframe);

    // Set form target to the iframe
    this.target = "form-submit-iframe";

    // Submit the form
    this.submit();

    // Show thank you message after a short delay
    setTimeout(() => {
      showThankYouMessage();
      // Clean up the iframe
      document.body.removeChild(iframe);
    }, 1500);
  });

function showThankYouMessage() {
  const form = document.querySelector(".waitlist-form") as HTMLFormElement;
  const formContainer = form.parentElement;

  if (formContainer) {
    formContainer.innerHTML = `
        <div class="thank-you-message">
            <h2>Thank you for joining the waitlist!</h2>
            <p>We'll be in touch soon with early access and priority onboarding details.</p>
            <p>Keep an eye on your inbox for updates about Rubikc's launch.</p>
            <div class="thank-you-icon">✓</div>
        </div>
    `;
  }
}

function init(): void {
  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupCubes());
  } else {
    setupCubes();
  }
}

function setupCubes() {
  document.querySelectorAll(".cube").forEach((cube) => {
    new WireframeCube(cube as HTMLElement);
  });
}

init();
